if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.$extra = document.querySelectorAll('[data-product-extra]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        //this.addExtrasToBag();
      }

      /*
      addExtrasToBag() {
        if (this.$extra.length > 0) {
          this.$extra.forEach(extra => {
            const checkboxes = extra.querySelectorAll('input[type=checkbox]');
            let timer;
            const extraAlert = extra.querySelector('[data-product-extra-alert]');
            let itemIndex = 1;
            for (let checkbox of checkboxes) {
              checkbox.addEventListener('click', e => {
                const el = e.target;
                const variantID = el.value;
                const productTitle = el.getAttribute('data-extra-product-title');
                const variantTitle = el.getAttribute('data-extra-variant-title');
                const variantPrice = el.getAttribute('data-extra-variant-price');
                const brand = el.getAttribute('data-extra-product-vendor');
                const productCategoryName = el.getAttribute('data-extra-product-category');
                const dataLayerItemObject = {
                  item_name: productTitle,
                  item_id: variantID,
                  item_list_name: "Complete the Look",
                  price: variantPrice / 100,
                  item_brand: brand,
                  item_category: productCategoryName,
                  item_variant: variantTitle,
                  item_list_id: "complete_the_look",
                  item_index: itemIndex++,
                  quantity: '1'
                };

                const config = {
                  method: 'POST',
                  headers: {
                    'Accept': `application/javascript`, 
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    sections: this.cart.getSectionsToRender().map((section) => section.id),
                    sections_url: window.location.pathname,
                    quantity: el.checked ? 1 : 0,
                    id: variantID,
                    properties: {
                      _complete_the_look: true
                    }
                  })
                }

                if (el.checked) {
                  this.cart.classList.remove('is-empty');
                } else {
                  this.cart.classList.add('is-empty');
                }

                if (typeof timer !== 'undefined') {
                  clearTimeout(timer);
                }

                if (el.checked) {
                  fetch(`${routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    const title = `Added ${productTitle} - ${variantTitle}!`;
                    extraAlert.innerText = title;
                    extraAlert.style.display = 'block';

                    window.addToCartEvent(dataLayerItemObject);

                    timer = setTimeout(() => {
                      extraAlert.innerText = '';
                      extraAlert.style.display = 'none';
                    }, 5000);

                    this.cart.renderContents(response, false);
                  }).catch(error => {
                    extraAlert.innerText = error.message;
                    extraAlert.style.display = 'block';
                    timer = setTimeout(() => {
                      extraAlert.innerText = '';
                      extraAlert.style.display = 'none';
                    }, 5000);
                  });
                } else {
                  fetch(`/cart/change.js`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response?.item_count > 0) {
                      this.cart.classList.remove('is-empty');
                    } else {
                      this.cart.classList.add('is-empty');
                    }

                    const title = `Removed ${productTitle} - ${variantTitle}!`;
                    extraAlert.innerText = title;
                    extraAlert.style.display = 'block';

                    window.removeFromCartEvent(dataLayerItemObject);

                    timer = setTimeout(() => {
                      extraAlert.innerText = '';
                      extraAlert.style.display = 'none';
                    }, 5000);

                    this.cart.renderContents(response, false);
                  }).catch(error => {
                    extraAlert.innerText = error.message;
                    extraAlert.style.display = 'block';
                    timer = setTimeout(() => {
                      extraAlert.innerText = '';
                      extraAlert.style.display = 'none';
                    }, 5000);
                  });
                }
              });
            }
          });
        }
      }
      */

      getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const jsonData = {};
        for (const [key, value] of formData) {
          jsonData[key] = value;
        }
        const json = jsonData;
        let printProductId;
        let printProductQty;

        const sendForm = (timeNow = undefined, formType = false) => {

          if (timeNow !== undefined) {
            formData.append('properties[_print_item_id]', timeNow);
          }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (response.status === 422 && printProductId && printProductQty) {
                fetch(`${routes.cart_change_url}`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
                  body: JSON.stringify({
                    id: printProductId,
                    quantity: 0
                  })
                })
                .then(response => {
                  return response.json();
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
              }

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (formType) {
              const nameField = formType.querySelector('[id="text"]');
              const numberField = formType.querySelector('[id="number"]');
              const alertEl = document.querySelector('.product-customize__alert');
              const inputs = formType.querySelectorAll('.product-hand-painted input[type=radio]');

              if (formType.classList.contains('product-jersey-print__form')) {
                document.cookie = 'jersey_print_name=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'jersey_print_number=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'jersey_print_font=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'jersey_print_color=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              } else if (formType.classList.contains('product-hand-painted__form')) {
                document.cookie = 'helmet_customization_font=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'helmet_customization_text=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'helmet_customization_color=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              }

              if (nameField) nameField.value = '';
              if (numberField) numberField.value = '';
              if (inputs.length) {
                inputs.forEach((el) => {
                  el.checked = false;
                })
              }
              if (alertEl) alertEl.classList.remove('active');
            }

            window.addToCartEvent(response);

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            document.dispatchEvent(new Event('custom:cart.addItem'));
          });
        }

        const printForm = document.querySelector('[data-product-jersey-print-form]');
        const paintedForm = document.querySelector('[data-product-hand-painted-form]');

        if (printForm) {
          const nameCookie = this.getCookie('jersey_print_name');
          const numberCookie = this.getCookie('jersey_print_number');
          const fontCookie = this.getCookie('jersey_print_font');
          const colorCookie = this.getCookie('jersey_print_color');
          const qtyInput = json.quantity;
          let printVarId = jerseyCustomization ? jerseyCustomization?.id : null;

          if (nameCookie && numberCookie && printVarId) {
            const skusJson = document.getElementById('product_skus');
            const productID = document.querySelector('[name="id"]').value;
            let currentSku = '';

            if (skusJson) {
              const skusJsonObj = JSON.parse(skusJson.innerText);
              skusJsonObj.forEach((el) => {
                if (el.id === Number(productID)) {
                  currentSku = el.sku;
                }
              })
            }

            let timeNow = Date.now();
            printProductId = printVarId;
            printProductQty = qtyInput ? qtyInput : 1;

            const props = {
              sku: currentSku,
              name: nameCookie,
              number: numberCookie,
              _print_id: timeNow.toString()
            }

            if (fontCookie) props.font = fontCookie;
            if (colorCookie) props.color = colorCookie;

            const printConfig = {
              method: 'POST',
              headers: {
                'Accept': `application/javascript`, 
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                sections: this.cart.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname,
                quantity: qtyInput ? qtyInput : 1,
                id: printVarId,
                properties: props
              })
            }

            fetch(`${routes.cart_add_url}`, printConfig)
            .then((response) => response.json())
            .then((response) => {
              sendForm(timeNow, printForm);
            }).catch(error => {
              sendForm();
            });
          } else {
            sendForm();
          }
        } else if (paintedForm) {
          const fontCookie = this.getCookie('helmet_customization_font');
          const nameCookie = this.getCookie('helmet_customization_text');
          const colorCookie = this.getCookie('helmet_customization_color');
          const qtyInput = json.quantity;

          if (fontCookie && nameCookie && colorCookie) {
            const skusJson = document.getElementById('product_skus_2');
            const varID = skusJson.getAttribute('data-product-id');
            const productID = document.querySelector('[name="id"]').value;
            let currentSku = '';

            if (skusJson) {
              const skusJsonObj = JSON.parse(skusJson.innerText);
              skusJsonObj.forEach((el) => {
                if (el.id === Number(productID)) {
                  currentSku = el.sku;
                }
              })
            }

            let timeNow = Date.now();
            printProductId = varID;
            printProductQty = qtyInput ? qtyInput : 1;

            const printConfig = {
              method: 'POST',
              headers: {
                'Accept': `application/javascript`, 
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                sections: this.cart.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname,
                quantity: qtyInput ? qtyInput : 1,
                id: varID,
                properties: {
                  font: fontCookie,
                  text: nameCookie,
                  color: colorCookie,
                  sku: currentSku,
                  _print_id: timeNow.toString()
                }
              })
            }

            fetch(`${routes.cart_add_url}`, printConfig)
            .then((response) => response.json())
            .then((response) => {
              sendForm(timeNow, paintedForm);
            }).catch(error => {
              sendForm();
            });
          } else {
            sendForm();
          }
        } else {
          sendForm();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
